// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6215":"92b223d9c7d416db","30801":"3cd374bb15361a18","89304":"4e6844f1fd5ae092"}[chunkId] + ".css";
};